import React from 'react'
import PanoPreview from '../../outdoor/PanoPreview'
import { TAG_FICHEPOI_IMMERSIVE } from '../../../store/analytics/analytics.actionTypes'
import s from './GeoentityBlock360.less'
import useTagBiForGeoentity from '../useTagBiForGeoentity'
import { SPD_GEOENTITY_OUTDOOR } from '../../analytics/BiTagger'
import { useSelector } from 'react-redux'
import { selectSelectedGeoentityIdentityCard } from '../../../store/geoentity/geoentity.selectors'

export default function GeoentityBlock360(props) {
  const { data = {} } = props
  const { url, closestPanoramicId, lat, lng } = data
  const { name } = useSelector(selectSelectedGeoentityIdentityCard)
  const sendBiTagNow = useTagBiForGeoentity(SPD_GEOENTITY_OUTDOOR)

  if (!data || !url) return null

  const panoData = {
    target: {
      lat,
      lng
    },
    panoramicId: closestPanoramicId,
    url
  }

  return (
    <div className={s.root}>
      <PanoPreview panoData={panoData} alt={name} tagId={TAG_FICHEPOI_IMMERSIVE} sendBiTag={sendBiTagNow} />
    </div>
  )
}
